const DashboardStyle = {
  dashboard: {
    margin: "auto",
    minHeight: "100vh",
  },
};

export default DashboardStyle;
